<ng-container *ngIf="transcript">
  <div class="transcript-wrapper" [class.mobile-transcript]="isMobile">
    <div class="transcript-header" [class.column-style]="!isMobile">
      <ng-container *ngIf="!isMobile; else mobileHeaderTpl">
        <mb-transcript-section-selection
          [options]="sections"
          [activeSection]="activeSection || ''"
          (sectionChanged)="sectionChanged($event)"
        >
        </mb-transcript-section-selection>
        <ng-container *ngIf="transcript.tags.length > 1">
          <div class="header-separator"></div>
          <mb-transcript-tag-selection
            [activeFilter]="transcript.filters"
            [tags]="transcript.tags"
            (selectionChange)="filtersChanged($event)"
          ></mb-transcript-tag-selection>
        </ng-container>
      </ng-container>

      <ng-template #mobileHeaderTpl>
        <mb-select
          *ngIf="transcript.tags.length > 1"
          [hideLabel]="true"
          [useNativeSelect]="false"
          [icon]="'mb-icon-filter-flat'"
          [options]="transcript.tagOptions"
          (selectionChanged)="filtersSelectChanged($event)"
        ></mb-select>
        <div class="close-btn btn btn-plain" (click)="closeTranscript.emit()">
          <span class="mb-icon mb-icon-close"></span>
        </div>
      </ng-template>
    </div>

    <mb-transcript-content
      [isMobile]="isMobile"
      [synced]="synced"
      [entries$]="transcript.entries"
      [speakers]="transcript.transcriptSpeakers"
      [player]="player"
      [disableActionAssets]="transcript.disableActionAssets"
      [disabledActionAssetsToastText]="transcript.disabledActionAssetsToastText"
      [currentEntry]="currentEntry"
      [activeEntry]="activeEntry"
      [displaySpeaker]="!transcript.filters.length"
      (scrolled)="contentScrolled()"
      (openMedia)="openMedia.emit($event)"
    ></mb-transcript-content>

    <div class="transcript-footer" [class.is-mobile]="isMobile">
      <div class="transcript-footer-left">
        <button class="btn btn-plain" *ngIf="!synced" (click)="sync()">
          <span class="mb-icon mb-icon-resync"></span>
          <span>{{ 'RESYNC' | translate }}</span>
        </button>
      </div>
      <div class="transcript-footer-right">
        <mb-dropdown
          *ngIf="transcript.languageOptions.length > 1"
          icon="mb-icon-language-country-switch"
          [value]="transcript.lang"
          (selectionChanged)="langChanged.emit($event ? $event.value : null)"
          [options]="transcript.languageOptions"
          [openTop]="true"
        ></mb-dropdown>
        <mb-action-container
          *ngIf="transcript.canBookmark"
          [buttonItems]="transcriptActions"
          [resource]="transcript"
        ></mb-action-container>
      </div>
    </div>
  </div>
</ng-container>
